module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS14.f3914ded.jpg";